import { Component, inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PLATFORM_ID } from '@angular/core';

import {
  Auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword
} from '@angular/fire/auth';

import {
  Firestore,
  doc,
  setDoc,
  getDoc
} from '@angular/fire/firestore';

/* Angular Material */
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-loginregister',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule
  ],
  templateUrl: './loginregister.component.html',
  styleUrl: './loginregister.component.css'
})
export class LoginregisterComponent {

  /* ---------------- DI ---------------- */
  private auth = inject(Auth);
  private firestore = inject(Firestore);
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private platformId = inject(PLATFORM_ID);

  showRegister = false;

  /* ---------------- FORMS ---------------- */
  registerForm: FormGroup = this.fb.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', Validators.required],
    password: ['', [Validators.required, Validators.minLength(6)]],
    confirmPassword: ['', Validators.required],
  });

  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  /* ---------------- REGISTER ---------------- */
  async register(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.registerForm.invalid) return;

    const { name, email, phone, password, confirmPassword } =
      this.registerForm.value;

    if (password !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    try {
      const cred = await createUserWithEmailAndPassword(
        this.auth,
        email,
        password
      );

      const profileId = cred.user.uid;

      await setDoc(doc(this.firestore, 'users', profileId), {
        profileId,
        name,
        email,
        phone,
        approved: false,
        createdAt: new Date()
      });

      alert('Registration successful. Wait for admin approval.');
      this.registerForm.reset();

    } catch (err: any) {
      alert(err.message || 'Registration failed');
    }
  }

  /* ---------------- LOGIN ---------------- */
  async login(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return;
    if (this.loginForm.invalid) return;

    const { email, password } = this.loginForm.value;

    try {
      const cred = await signInWithEmailAndPassword(
        this.auth,
        email,
        password
      );

      const profileId = cred.user.uid;
      const userRef = doc(this.firestore, 'users', profileId);
      const snap = await getDoc(userRef);

      if (!snap.exists()) {
        alert('User record not found');
        return;
      }

      const userData: any = snap.data();

      if (!userData.approved) {
        alert('Account not approved by admin');
        return;
      }

      this.router.navigate(['/adminpage']);

    } catch (err: any) {
      alert(err.message || 'Login failed');
    }
  }
}
